import { Button } from '@heroui/react';
import { ArrowLeft2 } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';

export const PrivacyOfPolicy = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={`flex h-[50px] gap-x-4
          bg-white fixed top-0 left-0 right-0 z-10 border-b px-4
            items-center -ml-4`}
      >
        <Button isIconOnly variant="light" onPress={() => navigate(-1)}>
          <ArrowLeft2 size="24" color="#222222" />
        </Button>

        <p className="text-[#222223] font-medium">
          Политика конфиденциальности
        </p>
      </div>
      <div className="w-full h-[50px]" />

      <div className="h-[calc(100vh-50px)] p-4 overflow-y-scroll">
        <p>
          1. Интернет-проект <a href="https://zerde24.kz">https://zerde24.kz</a>{' '}
          (Далее – «Сайт») серьезно относится к вопросу конфиденциальности
          информации своих Клиентов и Посетителей Сайта. Персональными данными
          является информация, признаваемая таковой согласно Закону Республики
          Казахстан “О персональных данных и их защите” (Далее – «Закон»), а
          именно фамилия, имя, отчество, адрес регистрации, места жительства,
          контактные телефоны, адреса электронной почты, номера банковских
          счетов, официальные реквизиты физического или юридического лица, логин
          и пароль Клиента и/или Посетителя сайта, а также информация о
          действиях, совершаемых вами на Сайте (например: Заказ Клиента с его
          контактной информацией). Анонимными мы называем данные, которые
          невозможно однозначно идентифицировать с конкретным Клиентом и/или
          посетителем сайта (например: статистика посещаемости сайта).
        </p>

        <p>
          2. Сообщение Клиентами и Посетителями Сайта персональных данных при
          совершении действий на Сайте является в соответствии с Законом
          конкретным, информированным и сознательным выражением согласия
          субъекта на обработку персональных данных. Клиент и/или Посетитель
          Сайта, в результате совершения действий на Сайте, подразумевающих под
          собой передачу Персональных данных, даёт согласие на сбор, хранение и
          обработку, в том числе, автоматизированную, информации, относящейся к
          Персональным данным, включая сбор, систематизацию, накопление,
          хранение, уточнение (обновление, изменение), использование,
          распространение (в том числе передачу третьим лицам), обезличивание,
          блокирование, уничтожение персональных данных. Обработка Персональных
          данных осуществляется исключительно в целях заключения с Клиентом
          Договора, надлежащего исполнения, осуществления расчётов с Клиентом,
          принятия решений или совершения иных действий, порождающих юридические
          последствия в отношении Клиента, предоставления Клиенту информации об
          оказываемых Компанией услугах, исполнения договорных обязательств
          перед третьими лицами, а также в целях информирования Клиента о новых
          продуктах и услугах, разрабатываемых и/или предлагаемых Компанией
          и/или его контрагентами и партнерами.
        </p>

        <p>
          3. Согласие дается Клиентом и/или Посетителем Сайта до истечения
          сроков хранения соответствующей информации или документов, содержащих
          вышеуказанную информацию, определяемых в соответствии с
          законодательством Республики Казахстан. Кроме того, согласие может
          быть отозвано путем направления Клиентом и/или Посетителем Сайта
          соответствующего письменного уведомления не менее чем за 3 (три)
          месяца до момента отзыва согласия. Отзыв согласия на обработку
          персональных данных означает односторонний отказ Клиента от Услуг.
        </p>

        <p>
          4. Если Клиент и/или Посетитель Сайта не желает, чтобы его
          персональные данные обрабатывались, то он должен обратиться по
          Контактам, указанным в п.8. Политики Конфиденциальности. В таком
          случае вся полученная от Клиента и/или Посетителя Сайта информация (в
          том числе логин и пароль) удаляется из клиентской базы и Клиент и/или
          Посетитель Сайта не сможет осуществлять Заказы на получение Услуг на
          сайте.
        </p>

        <p>5. Разглашение информации, полученной Компанией:</p>
        <ul>
          <li>
            Компания обязуется не разглашать полученную от Клиента информацию.
            Не считается нарушением предоставление Компанией информации агентам
            и третьим лицам, действующим на основании договора с Компанией, для
            исполнения обязательств перед Клиентом.
          </li>
          <li>
            Не считается нарушением обязательств разглашение информации в
            соответствии с обоснованными и применимыми требованиями закона, а
            также по требованию государственных органов Республики Казахстан.
          </li>
        </ul>

        <p>
          6. На Сайте используется технология «cookies». «Cookies» не содержат
          конфиденциальную информацию и не передаются третьим лицам.
        </p>

        <p>
          7. В случае возникновения подозрений относительно использования
          учетной записи Клиента и/или Посетителя Сайта третьим лицом или
          вредоносным программным обеспечением пароль от логин меняется во
          избежание нарушений безопасности Сайта.
        </p>

        <h2>8. Контакты</h2>
        <p>
          По вопросам, касающимся настоящей политики, просьба обращаться по
          адресу:
        </p>
        <p>
          Казахстан, город Алматы, Жетысуский район, улица Бокейханова, здание
          508
          <br />
          Тел: 87782006060, 87011668888, 87057200036
        </p>
      </div>
    </>
  );
};
